module.exports = __webpack_public_path__ + "img/skip.9f91e723.png";